import { apiClient } from "~/api/ApiClient";
import { PAGE_TITLES } from "~/configs/pageTitles";

import ExportsPage from "../ExportsPage/ExportsPage";

const BuiltLinksReports = () => (
  <ExportsPage
    exportType="BuiltLinkExport"
    createFn={(siteId) => apiClient.sites.builtLinkExportsCreate(siteId)}
    pageTitle={PAGE_TITLES.builtLinksReports}
    description="Use this page to create and download spreadsheet files of all of the links you have built for your site."
    successMessage="Built links report is generating"
    emptyText="Create your first built links report to get started."
  />
);

export default BuiltLinksReports;
